<template>
  <vs-prompt
    class="calendar-event-dialog"
    title="Update Time Off"
    accept-text= "Update Time Off"
    @accept="updateTime"
    @cancel="getData"
    :active.sync="activePromptUpdateEvent.isOpen">
      <div class="vx-row mb-4">
        <div class="vx-col sm:w-1/4 w-full flex align-center">
          <span class="text-sm">Day Off</span>
        </div>
        <div class="vx-col sm:w-3/4 w-full">
          <datepicker name="start-date" :disabledDates="disabledDates" v-model="startDate"></datepicker>
        </div>
      </div>
      <transition name="list">
      <div class="vx-row mb-4" v-if="active == false || active == 0">
        <div class="vx-col sm:w-1/4 w-full flex align-center">
          <span class="text-sm">Duration</span>
        </div>
        <div class="vx-col sm:w-3/4 w-full">
          <div class="flex align-center">
            <vue-timepicker class="w-1/2 mr-2 my-select-height" format="hh:mm A" v-model="startTime"></vue-timepicker> -
            <vue-timepicker class="w-1/2 ml-2 my-select-height" format="hh:mm A" v-model="endTime"></vue-timepicker>
          </div>
        </div>
      </div>
      </transition>
      <div class="vx-row w-full m-0 mb-4">
        <div class="vx-col sm:w-1/4 w-full"></div>
        <div class="vx-col sm:w-3/4 w-full flex align-center justify-between md:pl-2 pl-0 pr-0">
          <div class="flex align-left staff-allDay-inputs-holder">
            <!-- <div class="checkboxholder" :class="{'active' : active == 1}" id="timeOff-allday-checkbox" @click="changActive">
              <div class="checkboxwrapper">
                <a href="javascript:void(0);" class="checkBox"></a>
              </div>
              <span class="check-box-text text-sm">All Day</span>
            </div> -->
            <vs-checkbox class="all-day-checkbox mx-0" id="timeOff-allday-checkbox" v-model="active">All day</vs-checkbox>
          </div>
          <div class="more-option text-sm" @click="changeMoreOption">
            <a class="flex align-center" href="javascript:void(0);" v-if="moreOption == 0">
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4 stroke-current text-primary pr-1" /> More options
            </a>
            <a class="flex align-center" href="javascript:void(0);" v-else>
              <feather-icon icon="MinusIcon" svgClasses="h-4 w-4 stroke-current text-primary pr-1" /> More options
            </a>
          </div>
        </div>
      </div>
      <transition name="list">
        <div v-if="moreOption == 1" class="w-full">
          <div class="vx-row my-3">
            <div class="vx-col sm:w-1/4 w-full flex align-center">
                <label class="text-sm">Recurring?</label>
            </div>
            <div class="vx-col sm:w-3/4 w-full">
              <!-- <div class="staff-timeoff-inputs-holder" v-if="!recurring" @click="recurring = !recurring">
                <div class="slider_holder timeoff-recuring-holder sliderdone" id="timeoff-recuring-holder">
                  <input type="hidden" class="sliderVal" value="no">
                  <span class="slider_off sliders" style="left: 1px;"> OFF </span>
                  <span class="slider_on sliders" style="left: -57px;"> ON </span>
                  <span class="slider_switch" style="left: 0px;"></span>
                </div>
              </div>
              <div class="staff-timeoff-inputs-holder" v-else @click="recurring = !recurring">
                <div class="slider_holder timeoff-recuring-holder sliderdone" id="timeoff-recuring-holder">
                  <input type="hidden" class="sliderVal" value="yes">
                  <span class="slider_off sliders" style="left: 60px;"> OFF </span>
                  <span class="slider_on sliders" style="left: 2px;"> ON </span>
                  <span class="slider_switch" style="left: 38px;"></span>
                </div>
              </div> -->
              <vs-switch v-model="recurring">
                <span slot="on">On</span>
                <span slot="off">Off</span>
              </vs-switch>
            </div>
          </div>
          <transition name="list">
            <div v-if="recurring == true">
              <div class="vx-row my-3">
                <div class="vx-col sm:w-1/4 w-full flex align-center">
                  <span class="text-sm">Repeat</span>
                </div>
                <div class="vx-col sm:w-3/4 w-full">
                  <v-select class='repeat-select' v-model="repeatSelected" :options="repeatOptions" :dir="$vs.rtl ? 'rtl' : 'ltr'" :clearable="false"/>
                </div>
              </div>
              <div class="vx-row mb-3">
                <div class="vx-col sm:w-1/4 w-full flex align-center">
                  <span class="text-sm">End Date</span>
                </div>
                <div class="vx-col sm:w-3/4 w-full">
                  <datepicker name="end-date" :disabledDates="disabledEndDates" v-model="endDate"></datepicker>
                </div>
              </div>
            </div>
            </transition>
            <div class="vx-row mb-4 mt-1">
              <div class="vx-col sm:w-1/4 w-full flex align-center">
                <label class="text-sm">Description</label>
              </div>
              <div class="vx-col sm:w-3/4 w-full">
                <vs-input class="inputx description" placeholder="Vacation, Holiday, Other..." v-model="description" />
              </div>
            </div>
          </div>
          </transition>
  </vs-prompt>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import VueTimepicker from 'vue2-timepicker'
import vSelect from 'vue-select'
import moment from 'moment'

export default {
  name: 'update-time-off',
  components:{
    Datepicker,
    VueTimepicker,
    vSelect,
    moment
  },
  props: {
    activePromptUpdateEvent: {
      type: Object
    },
    blockTimeData: {
      type: Object
    },
    currentPage: {
      type: Number,
      default: 1
    },
    itemsPerpage: {
      type: Number,
      default: 5
    }
  },
  data(){
    this.getData(this.blockTimeData);
    return {
      disabledDates: {
        to: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate())
      },
      disabledEndDates: {
        to: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate())
      },
      startDate : '',
      description: '',
      active: false,
      startTime: '08:00 AM',
      endTime: '05:00 PM',
      moreOption : 0,
      recurring: false,
      repeatOptions: [
        {id: 1, label: 'Weekly'},
        {id: 2, label: 'Monthly'},
      ],
      repeatSelected: {id: 1, label: 'Weekly'},
      endDate: '',
      isOpenLoading : false,
    }
  },
  watch:{
    blockTimeData:{
      immediate: true,
      deep: true,
      handler(){
        this.getData(this.blockTimeData);
      }
    },
    activePromptUpdateEvent: {
      immediate: true,
      deep: true,
      handler() {
        if(this.activePromptUpdateEvent) {
          if(this.activePromptUpdateEvent.isOpen == false) {
            this.getData(this.blockTimeData);
          }
        }
      }
    }
  },
  methods:{
    getData(blockTimeData){
       if(blockTimeData){
          if(blockTimeData.all_day == 1){
            this.active = true;
            this.startDate = this.getFormatDate(blockTimeData.start_date.slice(0,10))
            // this.endDate = this.getFormatDate(blockTimeData.end_date.slice(0,10))
          }else{
            this.active = false;
            if(blockTimeData.start_date){
              this.startDate = this.getFormatDate(blockTimeData.start_date.slice(0,10))
              this.startTime = this.getFormatTime(blockTimeData.start_date.slice(11,16))
              this.endTime = this.getFormatTime(blockTimeData.end_date.slice(11,16))
            }
          }
          if(blockTimeData.recurring == 0){
            this.moreOption = 0;
            this.recurring = false;
          }else{
            this.moreOption = 1;
            this.recurring = true;
          }
          if(blockTimeData.data && blockTimeData.data.length != 0){
            if(blockTimeData.data.recurring_type == "weekly"){
              const obj = {id: 1, label: 'Weekly'}
              this.repeatSelected = obj;
            }else{
              const obj = {id: 2, label: 'Monthly'}
              this.repeatSelected = obj;
            }
            if(blockTimeData.data.recurring_end_date != null){
              this.endDate = this.getFormatDate(blockTimeData.data.recurring_end_date.slice(0,10))
            }else{
              this.endDate = '';
            }
          }
          this.description = blockTimeData.description;
          // if(this.endDate == ''){
          //   this.endDate = this.startDate
          // }
       }
    },
    getFormatDate(date){
      let dateTime = date.split('-');
      let myDate = new Date(dateTime[0], dateTime[1] - 1, dateTime[2])
      return myDate.toDateString();
    },
    getFormatTime(time){
      let stringTime = '';
      if(parseInt(time.slice(0,2)) < 12){
        if(parseInt(time.slice(0,2)) == 0){
          stringTime = String(parseInt(time.slice(0,2)) + 12) + time.slice(2,5) + ' AM'
        }else{
          stringTime = time + ' AM'
        }
      }else{
        if(parseInt(time.slice(0,2)) == 12){
           stringTime = String(parseInt(time.slice(0,2))) + time.slice(2,5) + ' PM'
        }
        else {
          if(parseInt(time.slice(0,2)) - 12 < 9){
            stringTime = '0' + String(parseInt(time.slice(0,2)) - 12) + time.slice(2,5) + ' PM'
          }else{
            stringTime = String(parseInt(time.slice(0,2)) - 12) + time.slice(2,5) + ' PM'
          }
        }
      }
      return stringTime;
    },
    changActive(){
      if(this.active == 1){
        this.active = 0;
      }else{
        this.active = 1;
      }
    },
    changeMoreOption(){
      if(this.moreOption == 1){
        this.moreOption = 0;
      }else{
        this.moreOption = 1;
      }
    },
    getTypeTime(time){
      let hasKey = 0;
      let stringTime = '';
      if(time.indexOf('P') != -1){
        hasKey = 1;
      }
     if(hasKey == 1){
        if(parseInt(time.slice(0,2)) < 12)
        {
          stringTime = String(parseInt(time.slice(0,2)) + 12) + time.slice(2,5);
        }else{
          stringTime = String(parseInt(time.slice(0,2))) + time.slice(2,5)
        }
      }else{
        if(parseInt(time.slice(0,2)) == 12){
          if(parseInt(time.slice(0,2)) - 12 == 0){
            stringTime = '0' + String(parseInt(time.slice(0,2)) - 12) + time.slice(2,5);
          }else{
            stringTime = String(parseInt(time.slice(0,2)) - 12) + time.slice(2,5);
          }
        }else{
          stringTime = time.slice(0,5);
        }
      }
      return stringTime
    },
    openLoadingInDiv(){
      this.$vs.loading({
        container: '#app',
        scale: 0.8
      })
      if(this.loadTime){
        clearTimeout(this.loadTime);
        this.loadTime = null;
      }
      this.isOpenLoading = true;
      this.loadTime = setTimeout( ()=> {
        if(this.isOpenLoading) {
          this.closeLoading();
          this.$vs.dialog({
            color: 'danger',
            title: 'Notification',
            text: this.action_type + ' block time failed',
            acceptText: 'OK'
          })
        }
      }, 10000);
    },
    closeLoading() {
      this.$vs.loading.close('#app > .con-vs-loading');
      this.isOpenLoading = false;
    },
    updateTime(){
      if(this.endDate != ''){
        if((new Date(this.startDate).getTime()) > (new Date(this.endDate).getTime())){
          this.endDate = this.startDate;
        }
      }
      const obj = {
        id: this.blockTimeData.id,
        staff_id: this.blockTimeData.staff_id == null ? '' : this.blockTimeData.staff_id,
        all_day: this.active == true || this.active == 1 ? 1 : 0,
        type: this.blockTimeData.type,
        recurring: this.recurring == false ? '0' : '1',
        description: this.description,
        page: this.currentPage,
        'per-page': this.itemsPerpage
      }
      const data = {};
      if(this.active == 1 || this.active == true) {
        obj.start_date = moment(this.startDate).format('YYYY-MM-DD 00:00:00');
        obj.end_date = moment(this.startDate).format('YYYY-MM-DD 00:00:00');
      }else{
        obj.start_date = moment(this.startDate).format('YYYY-MM-DD') + ' ' + this.getTypeTime(this.startTime) + ':00';
        obj.end_date = moment(this.startDate).format('YYYY-MM-DD') + ' ' + this.getTypeTime(this.endTime) + ':00';
      }
      if(this.recurring ==  true){
        if(this.repeatSelected.id == 1){
          data.recurring_type = 'weekly'
        }else{
          data.recurring_type = 'monthly'
        }
        if(this.active == 1 || this.active == true){
          if(this.endDate == ''){
            data.recurring_end_date = null;
            obj.end_date = moment(this.startDate).format('YYYY-MM-DD 00:00:00')
          }else{
            data.recurring_end_date = moment(this.endDate).format('YYYY-MM-DD 00:00:00')
            obj.end_date = moment(this.startDate).format('YYYY-MM-DD 00:00:00')
          }
        }else{
          if(this.endDate == ''){
            data.recurring_end_date = null;
            obj.end_date = moment(this.startDate).format('YYYY-MM-DD') + ' ' + this.getTypeTime(this.endTime) + ':00';
          }else{
            data.recurring_end_date = moment(this.endDate).format('YYYY-MM-DD') + ' ' + this.getTypeTime(this.endTime) + ':00';
            obj.end_date = moment(this.startDate).format('YYYY-MM-DD') + ' ' + this.getTypeTime(this.endTime) + ':00';
          }
        }
        obj.data = data;
      }
      this.openLoadingInDiv();
      this.$store.dispatch("business/UPDATE_BUSINESS_TIME_OFF", obj).then(() => {
          this.closeLoading();
          this.$vs.notify({
            title:'Notification',
            text:'Update Block Time Success',
            color:'success',
            position:'top-right'})
        }).catch(() => {
          this.closeLoading();
          this.$vs.notify({
            title:'Notification',
            text:'Update Block Time Failed',
            color:'danger',
            position:'top-right'})
        })
    },
  },
  created(){

  }
}
</script>
